module.exports = __webpack_public_path__ + "img/section3Card3Icon1.85b92445.png";